import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'

import Button from '../Button/Button'
import ButtonBlue from '../Button/ButtonBlue'
import { baseurl, baseurlLink, serverUrl } from '../Helpers/Config'
import { useLocation } from 'react-router-dom'
import { staticFiles } from '../Helpers/Static'
import { generateLink, getGeneratedLink, removeGeneratedLink } from '../../redux/actions/publicLink'
import { convertDateTime, tokenAuthorize } from '../Helpers/Common';
import { ButtonCommonTopNew, ButtonCommonTopGrey, ButtonCommonDelete, ActiveSpanColor, SideBarNormalCount } from '../../pages/Theme';
import { MdOutlineContentCopy } from "react-icons/md";
import { TbCopy } from "react-icons/tb";
import { MdDoneAll } from "react-icons/md";
import { MdContentCopy } from "react-icons/md";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { TbCopyCheckFilled } from "react-icons/tb";
import Swal from 'sweetalert2'
import { Card } from '../../pages/Theme'
import Tooltip from '@mui/material/Tooltip';
import { CopyToClipboard } from "react-copy-to-clipboard";;
const CROSS_GRAY_ICON = staticFiles.cross;

const ModalShowcaseLink = ({ handleClose, show }) => {
    const location = useLocation();
    const dispatch = useDispatch()
    const userGid = useSelector(state => state.auth?.user?.gid)
    const userProfile = useSelector(state => state.auth.user);
    const [profileLink, setProfileLink] = useState('');
    const [publicLink, setPublicLink] = useState('');
    const [publicPassword, setPublicPassword] = useState('');
    const [expiryDate, setExpiryDate] = useState('')
    const [disableGenerate, setDisableGenerate] = useState(false)
    const generatedLink = useSelector(state => state.publicLink.link)
    const isLoading = useSelector(state => state.publicLink.isLoading)
    const isSuccess = useSelector(state => state.publicLink.isSuccess)
    const errors = useSelector(state => state.publicLink.errors)
    const [copiedField, setCopiedField] = useState(null);

    useEffect(() => {
        setProfileLink(`${baseurlLink}/profile/${userGid}?profile_id=` + userProfile?.learner_profile_id)
    }, [userGid, userProfile])

    useEffect(() => {
        if (userProfile?.learner_profile_id != undefined && userProfile?.learner_profile_id != "") {
            dispatch(getGeneratedLink(userProfile?.learner_profile_id))
        }
    }, [userProfile])

    useEffect(() => {
        if (generatedLink && generatedLink.length !== 0) {
            //setPublicLink(`${baseurl}/login/public?code=${generatedLink.link}`)
            setPublicLink(`${baseurlLink}/public/${generatedLink.link}?profile_id=` + userProfile?.learner_profile_id)
            setPublicPassword(`${generatedLink.password}`)
            const convertedDate = convertDateTime(generatedLink.expiry_date)
            setExpiryDate(convertedDate)
            setDisableGenerate(true)
        }
        else {
            setPublicLink('')
            setPublicPassword('')
            setExpiryDate('')
            setDisableGenerate(false)
        }

    }, [generatedLink])


    const generatePublicLink = () => {
        dispatch(generateLink(userProfile?.learner_profile_id))

    }


    const removePublicLink = () => {
        Swal.fire({
            heightAuto: false,
            title: "Confirmation",
            text: "Are you sure you want to remove public link?",
            icon: "warning",
            showCancelButton: false,
            showDenyButton: true,
            confirmButtonText: "Confirm",
            denyButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            denyButtonColor: "#c1c1c1",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeGeneratedLink(userProfile?.learner_profile_id))

                    .then(() => {
                        Swal.fire({
                            heightAuto: false,
                            title: 'Success',
                            text: 'Public link has been removed',
                            icon: 'success'
                        });
                        setDisableGenerate(false)
                    })
                    .catch((err) => {
                        tokenAuthorize(err?.response?.status);
                        Swal.fire({
                            heightAuto: false,
                            title: 'Error',
                            text: 'Cannot remove public link',
                            icon: 'error'
                        });
                    })
            }
        });
    }

    const showHideModal = show
        ? 'block'
        : 'hidden'

    const copyLink = (copiedText, fieldName) => {
        // navigator?.clipboard?.writeText(copiedText);
        setCopiedField(fieldName);
        setTimeout(() => setCopiedField(null), 3000);
    };

    return (
        <div className={showHideModal} >
            <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}>
                    <div className="flex gap-2 items-center justify-between">
                        <p className="font-semibold blackColor">Get link</p>
                        <button
                            onClick={handleClose}
                            className="text-gray-600 hover:text-black text-xl font-bold"
                        >&times;
                        </button>
                    </div>
                    <div className='p-2'>
                        <div className="flex flex-col md:flex-row mt-2">
                            <label className="mr-2 md:mr-8 w-24 font-semibold md:py-3 md:whitespace-nowrap text-sm blackColor">Profile Link</label>
                            <div className="flex flex-row gap-3 items-center justify-between w-full">
                                <input
                                    type="text"
                                    value={profileLink}
                                    readOnly={true}
                                    disabled
                                    className="border border-gray-300 px-5 py-3 rounded-lg w-full"
                                />
                                <CopyToClipboard
                                    text={profileLink}
                                    onCopy={() => {
                                        copyLink(profileLink, "profile")
                                    }}
                                >
                                    {copiedField === "profile" ? (
                                        <Tooltip title={"Copied"} placement="top" arrow>
                                            <span>
                                                <MdDoneAll className="primaryIcon w-5 h-5" />
                                            </span>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title={"Copy profile link"} placement="top" arrow>
                                            <span>
                                                <MdContentCopy
                                                    className="cursor-pointer primaryIcon w-5 h-5"
                                                />
                                            </span>
                                        </Tooltip>
                                    )}
                                </CopyToClipboard>
                                {/* {copiedField === "profile" ? (
                                    <MdDoneAll className="primaryIcon w-5 h-5" />
                                ) : (
                                    <MdContentCopy
                                        className="cursor-pointer primaryIcon w-5 h-5"
                                        onClick={() => copyLink(profileLink, "profile")}
                                    />
                                )} */}

                            </div>
                        </div>
                        {
                            disableGenerate && <>
                                <hr className='my-4' />
                                <div className="flex flex-col space-y-5 ">
                                    <div className="flex flex-col md:flex-row md:items-center">
                                        <label className="mr-2 md:mr-8 w-24 font-semibold md:py-3 md:whitespace-nowrap text-sm blackColor">Public Link</label>
                                        <div className="flex flex-row gap-3 items-center justify-between w-full">
                                            <input
                                                type="text"
                                                value={publicLink}
                                                readOnly={true}
                                                disabled
                                                className="border border-gray-300 px-5 py-3 rounded-lg w-full"
                                            />
                                            <CopyToClipboard
                                                text={publicLink}
                                                onCopy={() => {
                                                    copyLink(publicLink, "public")
                                                }}
                                            >
                                                {copiedField === "public" ? (
                                                    <Tooltip title={"Copied"} placement="top" arrow>
                                                        <span>
                                                            <MdDoneAll className="primaryIcon w-5 h-5" />
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title={"Copy public link"} placement="top" arrow>
                                                        <span>
                                                            <MdContentCopy
                                                                className="cursor-pointer primaryIcon w-5 h-5"
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </CopyToClipboard>
                                            {/* <Button
                                            title='COPY LINK'
                                            onClick={() => copyLink(publicLink)}
                                        /> */}
                                        </div>
                                    </div>
                                    <div className="flex flex-col md:flex-row md:items-center">
                                        <label className="mr-2 md:mr-8 w-24 font-semibold md:py-3 md:whitespace-nowrap blackColor text-sm">Password</label>
                                        <div className="flex flex-row gap-3 items-center justify-between w-full">
                                            <input
                                                type="text"
                                                value={publicPassword}
                                                readOnly={true}
                                                disabled
                                                className="border border-gray-300 px-5 py-3 rounded-lg w-full"
                                            />
                                            <CopyToClipboard
                                                text={publicPassword}
                                                onCopy={() => {
                                                    copyLink(publicPassword, "password")
                                                }}
                                            >
                                                {copiedField === "password" ? (
                                                    <Tooltip title={"Copied"} placement="top" arrow>
                                                        <span>
                                                            <MdDoneAll className="primaryIcon w-5 h-5" />
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title={"Copy password"} placement="top" arrow>
                                                        <span>
                                                            <MdContentCopy
                                                                className="cursor-pointer primaryIcon w-5 h-5"
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </CopyToClipboard>
                                            {/* {copiedField === "password" ? (
                                                <MdDoneAll className="primaryIcon w-5 h-5" />
                                            ) : (
                                                <MdContentCopy
                                                    className="cursor-pointer primaryIcon w-5 h-5"
                                                    onClick={() => copyLink(publicPassword, "password")}
                                                />
                                            )} */}

                                            {/* <Button
                                            title='COPY PASS'
                                            className="h-12"
                                            onClick={() => copyLink(publicPassword)}
                                        /> */}
                                        </div>

                                    </div>
                                    <div className="flex flex-col md:flex-row md:items-center">
                                        <label className="mr-2 md:mr-8 w-24 font-semibold md:py-3 md:whitespace-nowrap blackColor text-sm">Expired at</label>
                                        <p>{expiryDate}</p>
                                    </div>
                                </div>
                            </>
                        }
                        <div className='flex justify-center mt-4'>
                            {!disableGenerate &&
                                <ButtonCommonTopNew
                                    className={`px-5 border p-2 text-sm rounded-lg ${isLoading ? "pointer-events-none" : "cursor-pointer"} `}
                                    onClick={generatePublicLink}
                                >{isLoading ? "Loading..." : "Generate Public Link"}</ButtonCommonTopNew>}
                            {disableGenerate &&
                                <ButtonCommonTopNew
                                    className={`px-5 border p-2 text-sm rounded-lg ${isLoading ? "pointer-events-none" : "cursor-pointer"} `}
                                    onClick={removePublicLink}
                                >{isLoading ? "Loading..." : "Remove Public Link"}</ButtonCommonTopNew>}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ModalShowcaseLink
